import React, { Component } from 'react';
import PropTypes from 'prop-types';

class BackLink extends Component {

    static defaultProps = {
        type: 'default',
        label: ''
    };

    static propTypes = {
        label: PropTypes.string.isRequired,
        type: PropTypes.string,
        onClick: PropTypes.func.isRequired
    }

    render() {
        const { type, label, onClick } = this.props;

        return (
            <div className={`BackLink BackLink--${type}`} onClick={onClick}>
                {label}
            </div>
        )
    }
}

export default BackLink;


// WEBPACK FOOTER //
// ./components/BackLink.js